import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "Section login-form"
};
var _hoisted_2 = {
  "class": "p-2xl"
};
var _hoisted_3 = {
  "class": "inputs"
};
var _hoisted_4 = {
  "class": "login-form__actions"
};
var _hoisted_5 = {
  "class": "text-center"
};
import ModalLoader from "@/components/ModalLoader.vue";
import { notify } from "@/utils/notifications";
import loginSuite from "@/validators/loginSuite";

import { defineAsyncComponent, reactive, ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default {
  __name: 'Login',
  setup: function setup(__props) {
    var EnableDisableTwoFaModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/pages/profile/tabs/modals/EnableDisableTwoFaModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var EnterTwoFaCodeModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/pages/auth/modals/EnterTwoFaCodeModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var ChangePasswordModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/pages/auth/modals/ChangePasswordModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var store = useStore();
    var router = useRouter();
    var form = reactive({
      email: null,
      password: null,
      recaptchaToken: ""
    });
    var error = ref(null);
    var loading = ref(false);
    var isChangePasswordModalOpen = ref(false);
    var isTwoFaModalOpened = ref(false);
    var isEnterTwoFaCodeModalOpened = ref(false);
    var passwordOn = ref(true);
    var passwordType = computed(function () {
      return passwordOn.value ? "password" : "text";
    });
    var validationResult = computed(function () {
      return loginSuite(form);
    });
    function unsetError() {
      error.value = null;
    }
    function onConfirmPasswordChange() {
      return _onConfirmPasswordChange.apply(this, arguments);
    }
    function _onConfirmPasswordChange() {
      _onConfirmPasswordChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _store$state$auth$use2;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return nextTick();
            case 2:
              if (!((_store$state$auth$use2 = store.state.auth.user) !== null && _store$state$auth$use2 !== void 0 && _store$state$auth$use2.twoFaEnabled)) {
                isTwoFaModalOpened.value = true;
              } else {
                router.push("/dashboard");
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _onConfirmPasswordChange.apply(this, arguments);
    }
    function onConfirmTwoFa() {
      return _onConfirmTwoFa.apply(this, arguments);
    }
    function _onConfirmTwoFa() {
      _onConfirmTwoFa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _store$state$auth$use3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return nextTick();
            case 2:
              if ((_store$state$auth$use3 = store.state.auth.user) !== null && _store$state$auth$use3 !== void 0 && _store$state$auth$use3.forcePasswordChange) {
                isEnterTwoFaCodeModalOpened.value = false;
                isChangePasswordModalOpen.value = true;
              } else {
                router.push("/profile");
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _onConfirmTwoFa.apply(this, arguments);
    }
    function onTwoFaLogin() {
      var _store$state$auth$use;
      if ((_store$state$auth$use = store.state.auth.user) !== null && _store$state$auth$use !== void 0 && _store$state$auth$use.forcePasswordChange) {
        isEnterTwoFaCodeModalOpened.value = false;
        isChangePasswordModalOpen.value = true;
      } else {
        router.push("/");
      }
    }
    function toggleTwoFaModal(value) {
      isTwoFaModalOpened.value = value;
      if (!value) {
        router.push("/");
      }
    }
    function toggleEnterTwoFaCodeModal(value) {
      isEnterTwoFaCodeModalOpened.value = value;
      if (value === false) {
        loading.value = false;
        form.recaptchaToken = "";
        store.commit("auth/setUser", null);
      }
    }
    function toggleChangePasswordModal(value) {
      isChangePasswordModalOpen.value = value;
      if (value === false) {
        loading.value = false;
        localStorage.clear();
        form.recaptchaToken = "";
      }
    }
    function submit() {
      return _submit.apply(this, arguments);
    }
    function _submit() {
      _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _store$state$auth$use4, _store$state$auth$use5, _store$state$auth$use6, _e$response$data$mess, _e$response, text;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!validationResult.value.isValid() || loading.value)) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              error.value = null;
              loading.value = true;
              _context3.prev = 4;
              _context3.next = 7;
              return store.dispatch("auth/login", form);
            case 7:
              if (!((_store$state$auth$use4 = store.state.auth.user) !== null && _store$state$auth$use4 !== void 0 && _store$state$auth$use4.twoFaEnabled)) {
                _context3.next = 11;
                break;
              }
              return _context3.abrupt("return", isEnterTwoFaCodeModalOpened.value = true);
            case 11:
              if (!((_store$state$auth$use5 = store.state.auth.user) !== null && _store$state$auth$use5 !== void 0 && _store$state$auth$use5.forcePasswordChange)) {
                _context3.next = 15;
                break;
              }
              return _context3.abrupt("return", isChangePasswordModalOpen.value = true);
            case 15:
              if (!((_store$state$auth$use6 = store.state.auth.user) !== null && _store$state$auth$use6 !== void 0 && _store$state$auth$use6.twoFaEnabled)) {
                isTwoFaModalOpened.value = true;
              }
            case 16:
              _context3.next = 25;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](4);
              text = (_e$response$data$mess = _context3.t0 === null || _context3.t0 === void 0 || (_e$response = _context3.t0.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 ? void 0 : _e$response.message) !== null && _e$response$data$mess !== void 0 ? _e$response$data$mess : "Something went wrong";
              form.recaptchaToken = "";
              error.value = text;
              loading.value = false;
              notify({
                text: text
              });
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 18]]);
      }));
      return _submit.apply(this, arguments);
    }
    store.dispatch("resetStore");
    return function (_ctx, _cache) {
      var _component_PBInput = _resolveComponent("PBInput");
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_Captcha = _resolveComponent("Captcha");
      var _component_PBButton = _resolveComponent("PBButton");
      var _component_RouterLink = _resolveComponent("RouterLink");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_PBInput, {
        modelValue: _unref(form).email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(form).email = $event;
        }),
        label: "Email",
        placeholder: "Enter email address",
        icon: "envelope",
        error: _unref(validationResult).getErrors('email')[0],
        "class": "mb-2xl",
        onEnter: submit,
        onKeyup: unsetError
      }, null, 8, ["modelValue", "error"]), _createVNode(_component_PBInput, {
        modelValue: _unref(form).password,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _unref(form).password = $event;
        }),
        label: "Password",
        placeholder: "Enter password",
        error: _unref(validationResult).getErrors('password')[0],
        type: _unref(passwordType),
        icon: "lock",
        "class": "mb-2xl",
        onEnter: submit,
        onKeyup: unsetError
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            "class": "text-zinc-500 cursor-pointer",
            name: _unref(passwordOn) ? 'eye-off' : 'eye',
            w: 22,
            h: 22,
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return passwordOn.value = !_unref(passwordOn);
            })
          }, null, 8, ["name"])];
        }),
        _: 1
      }, 8, ["modelValue", "error", "type"]), _createVNode(_component_Captcha, {
        modelValue: _unref(form).recaptchaToken,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _unref(form).recaptchaToken = $event;
        }),
        theme: "dark",
        "class": "mb-2xl"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_PBButton, {
        full: "",
        loading: _unref(loading),
        disabled: !_unref(validationResult).isValid(),
        large: "",
        "class": "mb-xl",
        onClick: submit
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Login ")];
        }),
        _: 1
      }, 8, ["loading", "disabled"]), _createElementVNode("div", _hoisted_5, [_createTextVNode(" Need an account? "), _createVNode(_component_RouterLink, {
        to: "/register"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Sign up ")];
        }),
        _: 1
      })])])])]), _unref(isChangePasswordModalOpen) ? (_openBlock(), _createBlock(_unref(ChangePasswordModal), {
        key: 0,
        "current-password": _unref(form).password,
        onConfirmPasswordChange: onConfirmPasswordChange,
        onClose: _cache[4] || (_cache[4] = function ($event) {
          return toggleChangePasswordModal(false);
        })
      }, null, 8, ["current-password"])) : _createCommentVNode("", true), _unref(isTwoFaModalOpened) ? (_openBlock(), _createBlock(_unref(EnableDisableTwoFaModal), {
        key: 1,
        "show-skip-button": "",
        onConfirmed: onConfirmTwoFa,
        onClose: _cache[5] || (_cache[5] = function ($event) {
          return toggleTwoFaModal(false);
        })
      })) : _createCommentVNode("", true), _unref(isEnterTwoFaCodeModalOpened) ? (_openBlock(), _createBlock(_unref(EnterTwoFaCodeModal), {
        key: 2,
        "on-two-fa-login": onTwoFaLogin,
        onClose: _cache[6] || (_cache[6] = function ($event) {
          return toggleEnterTwoFaCodeModal(false);
        })
      })) : _createCommentVNode("", true)]);
    };
  }
};